import React, { useEffect } from 'react';
import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ChecklistIcon from '@mui/icons-material/Checklist';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  background: 'rgba(255, 255, 255, 0.95)',
  borderRadius: theme.spacing(2),
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-10px)',
    boxShadow: theme.shadows[10],
  },
}));

const MajorActivities = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const activities = [
    "Conducted 8 research and studies on topically important issues for evidence-based policy dialogues and influencing.",
    "Organized 8 policy dialogues on the magnitude of all-inclusiveness and participatory level of the reform process in Oromia.",
    "Organized 9 meetings on the promotion of peace and peaceful coexistence in Oromia.",
    "Organized 11 meetings promoting peace among ethnic groups in Oromia and its cross-border regions.",
    "Held 2 policy dialogues on good governance and public service delivery in Oromia.",
    "Co-organized 24 GO-CSO Partnership Forum meetings in Oromia with the Oromia Finance Bureau.",
    "Organized 2 dialogues on the relationship between Abba Gadaas and Oromia Customary Courts.",
    "Organized 2 dialogues on the extent of CSOs' enabling operation space since CSO Proclamation No. 1113/19.",
    "Conducted 5 short-term training workshops on implementation capacity, rights-based advocacy, social inclusion, gender equality, and rights of PWDs.",
    "Published and distributed 7 research reports and 2 policy briefs to government offices, donor partners, and CSOs.",
  ];

  return (
    <Box sx={{ mt: 10, pb: 10, px: { xs: 2, sm: 4, md: 10 } }}>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          textAlign: 'center',
          mb: 4,
          color: '#1E88E5',
        }}
      >
        Major Activities Accomplished Over the Last Three Years
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          maxWidth: '900px',
          mx: 'auto',
          textAlign: 'center',
          mb: 6,
          lineHeight: 1.7,
        }}
      >
        Over the last three years, NeCSOO had undertaken the following major activities with financial provisions secured from different donor partners. In particular, NeCSOO remains grateful for the financial support of the European Union (EU) and the Civil Society Support Program 2 (CSSP2), without whose project funding these activities would not have been possible.
      </Typography>

      <Grid container spacing={6}>
        {/* First Column */}
        <Grid item xs={12} md={6}>
          <div data-aos="fade-up">
            <StyledCard>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <ChecklistIcon
                    color="primary"
                    sx={{ fontSize: 40, mr: 1 }}
                  />
                  <Typography variant="h5" fontWeight={600}>
                    Accomplished Activities (1–5)
                  </Typography>
                </Box>
                <Typography variant="body1" color="text.secondary">
                  <ul>
                    {activities.slice(0, 5).map((item, index) => (
                      <li key={index} style={{ marginBottom: '8px' }}>
                        {item}
                      </li>
                    ))}
                  </ul>
                </Typography>
              </CardContent>
            </StyledCard>
          </div>
        </Grid>

        {/* Second Column */}
        <Grid item xs={12} md={6}>
          <div data-aos="fade-up" data-aos-delay="200">
            <StyledCard>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <ChecklistIcon
                    color="primary"
                    sx={{ fontSize: 40, mr: 1 }}
                  />
                  <Typography variant="h5" fontWeight={600}>
                    Accomplished Activities (6–10)
                  </Typography>
                </Box>
                <Typography variant="body1" color="text.secondary">
                  <ul>
                    {activities.slice(5).map((item, index) => (
                      <li key={index} style={{ marginBottom: '8px' }}>
                        {item}
                      </li>
                    ))}
                  </ul>
                </Typography>
              </CardContent>
            </StyledCard>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MajorActivities;
